module.exports = __webpack_public_path__ + "static/img/logo.13877f82.svg";